/* DO NOT FORGET to add export of this file to /src/store/reducers/index.js */
import * as FP from '../../utils/fp-js';

export const messages = (state, action) =>
  FP.match(action.type).on('SET_messages', action.payload).otherwise(state);
